import { joinParts } from './utils'

export const promoter = {
  components: (codeUrl: string) => joinParts('promoter', codeUrl),
}
